import React from 'react';
import { Field } from '../../components/ui';
import StepNav from './StepNav';

// Mobile "Setup Event" wizard — full-width, stacked fields, big buttons.
// Separate JSX from desktop; shared logic via the vm.
export default function SetupMobile({ vm }) {
  const {
    step, saving, canFunctions, canGuests,
    functions, fnOptions, activeFn, activeFnId, setActiveFnId, pickExistingFunction,
    fnForm, setFn, saveFunction,
    guestForm, setGuest, saveGuest, guestsAdded,
    memberForm, setMember, saveMember, membersAdded,
    FUNCTION_TYPE_OPTIONS, goStep,
    canImport, importGuestContact, importMemberContact,
  } = vm;

  return (
    <div>
      <div className="page-head"><h1>Setup Event</h1></div>
      <StepNav vm={vm} />

      {step === 1 && (
        <div className="card card-pad">
          {!canFunctions ? (
            <div className="empty">Only the Event Owner / Admin can add functions. Tap “2. Guests” to continue.</div>
          ) : (
            <>
              <h3 style={{ marginTop: 0 }}>Step 1 · Add a Function</h3>
              <Field label="Function Name" value={fnForm.FunctionName} onChange={v => setFn('FunctionName', v)} required />
              <Field label="Type" type="select" value={fnForm.FunctionType} options={FUNCTION_TYPE_OPTIONS} onChange={v => setFn('FunctionType', v)} />
                {fnForm.FunctionType === 'Other' && <Field label="New type name" value={fnForm.FunctionTypeOther} onChange={v => setFn('FunctionTypeOther', v)} />}
              <Field label="Date" type="date" value={fnForm.FunctionDate} onChange={v => setFn('FunctionDate', v)} />
              <Field label="Time" type="time" value={fnForm.FunctionTime} onChange={v => setFn('FunctionTime', v)} />
              <Field label="Venue" value={fnForm.Venue} onChange={v => setFn('Venue', v)} />
              <Field label="City" value={fnForm.City} onChange={v => setFn('City', v)} />
              <Field label="Venue Address" type="textarea" value={fnForm.VenueAddress} onChange={v => setFn('VenueAddress', v)} />
              <Field label="GPS Location (lat,lng or Maps link)" type="textarea" value={fnForm.GpsLocation} onChange={v => setFn('GpsLocation', v)} />
              <button className="btn primary" style={{ width: '100%', padding: 13, marginTop: 8 }} disabled={saving} onClick={saveFunction}>
                {saving ? 'Saving…' : 'Save & Add Guests →'}
              </button>

              {functions.length > 0 && (
                <div style={{ marginTop: 16, borderTop: '1px solid var(--line)', paddingTop: 12 }}>
                  <div className="muted" style={{ fontSize: 13, marginBottom: 8 }}>…or pick an existing function:</div>
                  <div style={{ display: 'grid', gap: 8 }}>
                    {functions.map(f => (
                      <button key={f.FunctionId} className="btn light" onClick={() => pickExistingFunction(f.FunctionId)}>
                        {f.FunctionName} →
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}

      {step === 2 && (
        <div className="card card-pad">
          {!canGuests ? (
            <div className="empty">You don't have permission to add guests.</div>
          ) : (
            <>
              <h3 style={{ marginTop: 0 }}>Step 2 · Add Guests</h3>
              {activeFn && <div className="muted" style={{ fontSize: 13, marginBottom: 8 }}>into “{activeFn.FunctionName}”</div>}
              <Field label="Function" type="select" value={activeFnId} options={fnOptions} onChange={setActiveFnId} required />
              {canImport && <button type="button" className="btn light sm" style={{ marginBottom: 6 }} onClick={importGuestContact}>📇 Phone book</button>}
                <Field label="Guest Name" value={guestForm.GuestName} onChange={v => setGuest('GuestName', v)} required />
              <Field label="Mobile Number" value={guestForm.MobileNumber} onChange={v => setGuest('MobileNumber', v)} />
              <Field label="Relation" value={guestForm.Relation} onChange={v => setGuest('Relation', v)} />
              <Field label="Expected Pax" type="number" value={guestForm.ExpectedCount} onChange={v => setGuest('ExpectedCount', v)} />
              <button className="btn primary" style={{ width: '100%', padding: 13, marginTop: 8 }} disabled={saving} onClick={() => saveGuest({ keepGoing: true })}>
                {saving ? 'Saving…' : '+ Add & Add Another'}
              </button>
              <button className="btn light" style={{ width: '100%', padding: 12, marginTop: 8 }} disabled={saving} onClick={() => saveGuest({ keepGoing: false })}>
                Add & Go to Members →
              </button>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                <button className="btn light sm" onClick={() => goStep(3)}>Skip to Members →</button>
                <div style={{ flex: 1 }} />
                <span className="muted" style={{ fontSize: 13 }}>{guestsAdded} added</span>
              </div>
            </>
          )}
        </div>
      )}

      {step === 3 && (
        <div className="card card-pad">
          {!canGuests ? (
            <div className="empty">You don't have permission to add members.</div>
          ) : (
            <>
              <h3 style={{ marginTop: 0 }}>Step 3 · Add Members</h3>
              <div className="muted" style={{ fontSize: 13, marginBottom: 8 }}>
                A member is a person invited to the event — pick their function.
              </div>
              <Field label="Function" type="select" value={memberForm.FunctionId} options={fnOptions} onChange={v => setMember('FunctionId', v)} required />
              {canImport && <button type="button" className="btn light sm" style={{ marginBottom: 6 }} onClick={importMemberContact}>📇 Phone book</button>}
                <Field label="Member Name" value={memberForm.GuestName} onChange={v => setMember('GuestName', v)} required />
              <Field label="Mobile Number" value={memberForm.MobileNumber} onChange={v => setMember('MobileNumber', v)} />
              <Field label="Relation" value={memberForm.Relation} onChange={v => setMember('Relation', v)} />
              <Field label="Expected Pax" type="number" value={memberForm.ExpectedCount} onChange={v => setMember('ExpectedCount', v)} />
              <button className="btn primary" style={{ width: '100%', padding: 13, marginTop: 8 }} disabled={saving} onClick={() => saveMember({ keepGoing: true })}>
                {saving ? 'Saving…' : '+ Add & Add Another'}
              </button>
              <button className="btn light" style={{ width: '100%', padding: 12, marginTop: 8 }} disabled={saving} onClick={() => saveMember({ keepGoing: false })}>
                Add & Finish
              </button>
              <div style={{ textAlign: 'right', marginTop: 10 }}>
                <span className="muted" style={{ fontSize: 13 }}>{membersAdded} added</span>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
